import React from 'react';
import { createPortal } from 'react-dom';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from '../../ui/button';

interface DeleteDocumentTypeDialogProps {
  open: boolean;
  documentTypeName?: string;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteDocumentTypeDialog({
  open,
  documentTypeName,
  onClose,
  onConfirm,
}: DeleteDocumentTypeDialogProps) {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6 animate-fadeIn">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-4 mb-4">
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-6 h-6 text-red-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Hapus Jenis Dokumen?</h3>
          </div>
        </div>
        <p className="text-gray-600 mb-6">
          Apakah Anda yakin ingin menghapus jenis dokumen{' '}
          {documentTypeName && <span className="font-semibold">"{documentTypeName}"</span>}?
          Tindakan ini tidak dapat dibatalkan.
        </p>
        <div className="flex justify-end gap-3">
          <Button variant="outline" onClick={onClose}>
            Batal
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Hapus
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
}
